import { SPIN_THE_WHEEL } from '../../constants/gameRouteEntries';

const initialState = {
  gameType: SPIN_THE_WHEEL.toUpperCase(),
  wheelData: {
    apiStatus: '',
    apiStatusMessage: ''
  },
  rewardsData: {
    apiStatus: '',
    apiStatusMessage: ''
  }
};

export function spinTheWheelReducer(state = initialState, action) {
  const { type = '', data = {}, apiStatus = '', apiStatusMessage = '' } = action || {};
  switch (type) {
    case 'GET_GAME_INFO_SUCCESS':
      return { ...state, wheelData: { ...data, apiStatus, apiStatusMessage } };
    case 'GET_GAME_INFO_ERROR':
      return { ...state, wheelData: { apiStatus, apiStatusMessage } };
    case 'GET_GAME_REWARDS_SUCCESS':
      return { ...state, rewardsData: { ...data, apiStatus, apiStatusMessage } };
    case 'GET_GAME_REWARDS_ERROR':
      return { ...state, rewardsData: { apiStatus, apiStatusMessage } };
    default:
      return state;
  }
}
